import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Container,
  useTheme,
  useMediaQuery,
  Stack
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Link } from "react-router-dom";
import RecifeBemLogo from "~/images/illustrations/bora-impactar.svg";
import { APP_ROUTES } from "~/single-page/constants/routes";

const RegistrationSuccess = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const buttonStyles = {
    px: 4, 
    py: 1.2,
    borderRadius: 1,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: { xs: '0.95rem', sm: '1.05rem' },
    boxShadow: '0 4px 8px rgba(41, 75, 182, 0.25)',
    minWidth: { xs: '100%', sm: '200px' }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: { xs: 3, sm: 5 }, 
          borderRadius: 2,
          textAlign: 'center',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            mb: 4 
          }}
        >
          <img 
            src={RecifeBemLogo} 
            alt="Bora Impactar Logo" 
            style={{ 
              height: isMobile ? 50 : 65,
              marginBottom: 24
            }} 
          />
          
          <CheckCircleOutlineIcon 
            sx={{ 
              fontSize: isMobile ? 60 : 80, 
              color: theme.palette.primary.main,
              mb: 2 
            }} 
          />
          
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontWeight: 600,
              fontSize: { xs: '1.5rem', sm: '2rem' },
              color: theme.palette.primary.main
            }}
          >
            Cadastro Enviado com Sucesso!
          </Typography>
        </Box>

        <Typography 
          variant="body1"
          paragraph
          sx={{ 
            fontSize: { xs: '1rem', sm: '1.1rem' },
            mb: 2,
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          Sua solicitação foi recebida e está em análise pela nossa equipe.
        </Typography>
        
        <Typography 
          variant="body1"
          paragraph
          sx={{ 
            fontSize: { xs: '1rem', sm: '1.1rem' },
            mb: 4,
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          O responsável cadastrado receberá um email com informações sobre o status da solicitação. Fique atento à sua caixa de entrada.
        </Typography>

        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          justifyContent="center"
          sx={{ mt: 2 }}
        >
          <Button
            component={Link}
            to="/"
            variant="outlined"
            color="primary"
            size={isMobile ? "medium" : "large"}
            sx={buttonStyles}
          >
            Voltar para a Página Inicial
          </Button>

          <Button
            component={Link}
            to={APP_ROUTES.SIGN_IN}
            variant="contained"
            color="primary"
            size={isMobile ? "medium" : "large"}
            sx={buttonStyles}
          >
            Fazer Login
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default RegistrationSuccess; 